import {ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {StructureMegamenu} from './structure_menu.model';
import {RouterLink} from '@angular/router';
import {AppIconComponent} from "@shared/components/app-icon";


@Component({
  selector: 'app-megamenu',
  templateUrl: './megamenu.component.html',
  styleUrl: './megamenu.component.scss',
  standalone: true,
  imports: [RouterLink, AppIconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MegamenuComponent implements OnInit {
  @Input() objMegamenu: StructureMegamenu;
  @Output() closeMenu: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit(): void {}

  navigateByUrl( url: string ) {
    if ( url && url.length > 0 ) {
      return window.open( url );
    }
    return null;
  }
}


